import axios from "axios";
import { STATUSES } from "./apiStatus";
import { base_url } from "../utils";
import { getAccesstoken } from "../helpers/utils";
const { createSlice, createAsyncThunk } = require("@reduxjs/toolkit");

export const creditRch = createAsyncThunk("creditRch/fetch",async (_, { rejectWithValue, serializeError }) => {
    try {
      const token = getAccesstoken();
      const response = await axios.get(`${base_url}/digilocker/get_credit_recharge_logs`,{
         headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      )
      console.log("rtk response data", response)
      return response.data;
    } catch (error) {
      console.error("API error:", error);
      return rejectWithValue(serializeError(error));
    }
  },
  {
    serializeError: (err) => err.message,
  }
);

const creditRchSlice = createSlice({
  name: "creditRch",
  initialState: {
    creditRchdata: {},
    status: "idle",
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(creditRch.pending, (state, action) => {
        state.status = STATUSES.LOADING;
      })
      .addCase(creditRch.fulfilled, (state, action) => {
        state.creditRchdata = action.payload;
        state.status = STATUSES.IDLE;
      })
      .addCase(creditRch.rejected, (state, action) => {
        state.status = STATUSES.ERROR;
      });
  },
});

export default creditRchSlice.reducer;
